import React, { useState } from "react";
import { marked } from "marked";

const RemoteMarkdown = (props) => {
  const [html, setHtml] = useState("");
  const src = props.src;
  async function fetchMarkdown() {
    try {
      const response = await fetch(src);
      if (response.status !== 200) throw new Error("bad request");
      const text = await response.text();
      setHtml(marked(text));
    } catch (error) {
      console.log(`failed to load markdown from: ${src}`);
      setHtml("<h3>Failed to load</h3>");
    }
  }

  fetchMarkdown();
  return (
    <div style={props.style || {}} dangerouslySetInnerHTML={{ __html: html }} />
  );
};

export default RemoteMarkdown;
